import React from 'react'

import { ButtonProps } from 'widgets/Button'
import { Modal } from 'widgets/Modal'
import { Text } from 'widgets/Text'

import { EULA } from 'utils/strings/eula'

interface Props {
  handleClose: () => void
  acceptAgreement?: () => void
  isOpen: boolean
  testID?: string
}

export const TermsModal = ({
  handleClose,
  acceptAgreement,
  isOpen,
  testID,
}: Props): JSX.Element => {
  const actionButtonProps: ButtonProps[] =
    acceptAgreement !== undefined
      ? [
          {
            title: 'Close',
            onPress: handleClose,
            type: 'grey',
          },
          {
            title: 'Accept',
            onPress: acceptAgreement,
            type: 'primary',
          },
        ]
      : [
          {
            title: 'Close',
            onPress: handleClose,
            type: 'grey',
          },
        ]

  return (
    <Modal
      actionButtonProps={actionButtonProps}
      isVisible={isOpen}
      onClose={handleClose}
      title='Mobile Application End User License Agreement'
      testID={testID}
    >
      <Text fontSize='xs'>{EULA}</Text>
    </Modal>
  )
}
